import { extendTheme, theme as baseTheme } from "@chakra-ui/react";
import { CardComponent } from "./additions/card/card";
import { buttonStyles } from "./components/button";
import { badgeStyles } from "./components/badge";
import { inputStyles } from "./components/input";
import { progressStyles } from "./components/progress";
import { sliderStyles } from "./components/slider";
import { textareaStyles } from "./components/textarea";
import { switchStyles } from "./components/switch";
import { linkStyles } from "./components/link";
import { breakpoints } from "./foundations/breakpoints";
import { globalStyles } from "./styles";

export default extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === 'light' ? '#f2f6fd' : 'navy.900',
        color: props.colorMode === 'light' ? 'gray.900' : 'white',
      },
    }),
  },
  colors: {
    ...baseTheme.colors,
    navy: {
      50: '#d0dcfb',
      100: '#aac0fe',
      200: '#a3b9f8',
      300: '#728fea',
      400: '#3652ba',
      500: '#1b3bbb',
      600: '#24388a',
      700: '#1B254B',
      800: '#0f1535',
      900: '#0f1535',
    },
  },
  components: {
    Card: {
      baseStyle: (props) => ({
        bg: props.colorMode === "light" ? "white" : "navy.700",
        color: props.colorMode === "light" ? "gray.900" : "white",
        boxShadow: 'lg',
        borderRadius: 'xl'
      }),
    },
    Box: {
      variants: {
        panel: (props) => ({
          bg: props.colorMode === "light" ? "white" : "navy.800",
          color: props.colorMode === "light" ? "gray.900" : "white",
          boxShadow: "sm",
          borderRadius: "lg",
        }),
        "with-shadow": {
          bg: 'white',
          borderRadius: 'xl',
          boxShadow: 'lg',
          _dark: {
            bg: 'navy.800',
          }
        }
      },
    },
    Text: {
      baseStyle: (props) => ({
        color: props.colorMode === "light" ? "gray.700" : "whiteAlpha.900",
      }),
    },
    Stat: {
      baseStyle: (props) => ({
        label: {
          color: props.colorMode === "light" ? "gray.500" : "whiteAlpha.600",
        },
        number: {
          color: props.colorMode === "light" ? "gray.900" : "white",
        },
        helpText: {
          color: props.colorMode === "light" ? "gray.500" : "whiteAlpha.600",
        },
      }),
    },
  },
  breakpoints, // Breakpoints
  globalStyles,
  badgeStyles, // badge styles
  buttonStyles, // button styles
  linkStyles, // link styles
  progressStyles, // progress styles
  sliderStyles, // slider styles
  inputStyles, // input styles
  textareaStyles, // textarea styles
  switchStyles, // switch styles
  CardComponent // card component
});
